// extracted by mini-css-extract-plugin
export default {"wrapper":"JVQQAd1vBEkWpgbiH6wH","spinner":"dbNvJfPvYVjbHPf8Topc","rotate":"SMKp_W9v6gety5k24_TU","path":"O6Ow94JFnY91YQJ7M0zD","dash":"O7t9F_SqBI8O9InGrbPu"};